import { type MultiSelectProps } from '@mantine/core';
import { FormMultiselect } from '@shared/ui';
import { useGetEconomicActivities } from '../../api';

type FormEconomicActivityMultiSelectProps = Omit<
  MultiSelectProps,
  'data' | 'description' | 'placeholder' | 'title'
> & {
  placeholder?: string;
};

export const FormEconomicActivityMultiSelect = ({
  placeholder = 'Выберите',
  ...props
}: FormEconomicActivityMultiSelectProps) => {
  const { data, isLoading } = useGetEconomicActivities();

  return (
    <FormMultiselect
      title='Сфера экономической деятельности'
      description='Выберите все сферы экономической деятельности компании'
      placeholder={placeholder}
      data={
        data?.data.map(activity => ({
          label: activity.name,
          value: activity.id.toString(),
        })) ?? []
      }
      isLoading={isLoading}
      searchable
      clearable
      {...props}
    />
  );
};
